<style lang="scss" scoped>
.header-top {
  height: 30px;
}

.search-bar {
  --size: 30px;
  display: flex;
  height: var(--size);
  width: var(--size);
  padding: 3px;
  position: relative;
  transition: width 500ms cubic-bezier(0.18, 0.89, 0.32, 1.15);
  overflow: hidden;

  &__input {
    font-size: 14px;
    border: 0;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    line-height: calc(var(--size) - 3px);
    opacity: 0;
    cursor: pointer;
  }

  &__submit {
    font-size: 14px;
    cursor: pointer;
    border: 0;
    background: transparent;
    width: calc(var(--size) - 10px);
    height: calc(var(--size) - 10px);
    margin-left: auto;
  }

  &:focus-within {
    width: 20%;
    // outline: 2px solid #191919;
    // box-shadow: 0 0 10px rgba(0, 0, 0, 0.35);

    .search-bar__input {
      opacity: 1;
      cursor: initial;
      width: calc(100% - var(--size));
      margin-left: 20px;
      padding-left: 4px;
      box-shadow: none;
      outline: 0;
      background: white;
    }

    .search-bar__submit {
      color: #191919;
      background: #fff;
      box-shadow: 0 0 10px rgba(0, 0, 0, 0.15);
      left: 0;
      top: 0;
      bottom: 0;
      height: var(--size);
      position: absolute;

      &:hover {
        outline: 2px solid #191919;
        box-shadow: 0 0 10px rgba(0, 0, 0, 0.35);
      }
    }
  }
}

#nav-bar {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

#nav-bar ul {
  display: flex;
  list-style: none;
  white-space: nowrap;
  text-align: left;
  background-color: transparent;
}

#nav-bar ul li {
  display: block;
  text-decoration: none;
  padding: 8px 8px 5px;
}

#nav-bar ul li a {
  color: #000;
}

.form-control-mobile-navbar-footer {
  display: block;
  height: calc(1.5em + 0.75rem + 2px);
  width: 100%;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #d0d0d0;
  border-radius: 0.25rem;
  transition:
    border-color 0.15s ease-in-out,
    box-shadow 0.15s ease-in-out;
}

.search-input {
  width: 100%;
  background: url(https://unity.web.asu.edu/@asu-design-system/bootstrap4-theme/static/media/search-gray-6.86a31198.svg)
    no-repeat 10px 50%;
  background-size: 16px;
  background-color: #fff;
  border: 0;
  border-radius: 0;
  padding-left: 32px;
  border-radius: 0;
}

/* Mobile container styling */
@media (max-width: 767px) {
  .container {
    width: 100% !important;
    max-width: none !important;
    padding-left: 15px !important;
    padding-right: 15px !important;
  }
}

/* Fix text transform for buttons to prevent all caps */
.v-btn {
  text-transform: none !important;
}

/* Fix mobile footer text color */
.nav-grid-mobile .nav-link {
  color: #fff !important;
}

.nav-grid-mobile .text-dark {
  color: #fff !important;
}

/* Fix mobile navigation menu text color */
#asu_mobile_menu {
  color: #fff !important;
}

#asu_mobile_menu .nav-link {
  color: #fff !important;
}

#asu_mobile_menu a {
  color: #fff !important;
}

/* Additional mobile nav styling */
.d-md-none .nav-link {
  color: #fff !important;
}
</style>
<template>
  <div>
    <app-notice-banner id="banner-12" />
    <div
      class="header-top d-none d-md-flex"
      style="background: #e8e8e8; display: flex; flex-direction: row-reverse; font-size: 12px; margin-bottom: 5px"
    >
      <!-- v-container, not a bare .container: the row below is one too, and a bare
           .container gets Bootstrap's fixed 1170px instead, so the two rows of the
           header were misaligned by 315px a side on wide screens. -->
      <v-container style="padding-top: 0px; padding-bottom: 0px" class="container header-container">
        <div id="asu_nav_wrapper">
          <div id="asu_nav_menu" style="width: 100%" role="navigation" aria-label="ASU">
            <div id="nav-bar">
              <ul>
                <li>
                  <a href="//www.asu.edu/" target="_blank" @click="asuoDataLayerClick('appHeader', '0')">ASU Home</a>
                </li>
                <li>
                  <a href="//my.asu.edu/" target="_blank" @click="asuoDataLayerClick('appHeader', '1')">My ASU</a>
                </li>
                <li>
                  <a href="//www.asu.edu/colleges/" target="_blank" @click="asuoDataLayerClick('appHeader', '2')"
                    >Colleges and Schools</a
                  >
                </li>
              </ul>
              <div class="search-bar">
                <button class="search-bar__submit" aria-label="open ASU search">
                  <v-icon>mdi-magnify</v-icon>
                </button>
                <input
                  type="search"
                  class="search-bar__input"
                  name="search asu"
                  id="search-asu"
                  aria-label="search ASU"
                  placeholder="Search ASU"
                  v-model="desktopSearchText"
                  @keyup.enter="searchAsu"
                  @change="
                    asuoDataLayerClick('appHeader', '3', {
                      text: desktopSearchText,
                      section: 'topbar',
                      name: 'onenter'
                    })
                  "
                />
              </div>
            </div>
          </div>
        </div>
      </v-container>
    </div>

    <div id="LoggedIn" style="border-bottom: 2px solid #f2f2f2; margin-top: 20px">
      <div id="asu_header" role="banner" class="d-print-none">
        <v-container class="container" style="padding-top: 0; padding-bottom: 0">
          <!-- ASU Logo and Content Layout (matching Vue 2 structure) -->
          <v-row no-gutters align="center" class="d-none d-md-flex justify-space-between">
            <!-- Column 1: ASU Logo -->
            <v-col cols="auto" style="margin-top: -20px">
              <div id="asu_hdr" class="asu_hdr_white chrome">
                <div style="display: flex; align-items: center">
                  <a href="//www.asu.edu/" target="_top" style="display: flex">
                    <img
                      alt="A S U"
                      src="../assets/images/asu_logo.png"
                      @click="asuoDataLayerClick('SecondaryHeaderComponent', '10')"
                    />
                  </a>
                </div>
              </div>
            </v-col>

            <!-- Column 2: Title + Secondary Header (aligned like Vue 2) -->
            <v-col class="ml-4">
              <!-- Title Section -->
              <div style="margin-bottom: 8px">
                <div v-if="isLoggedin" style="font: normal normal bold 16px/18px Arial">
                  <a
                    style="color: black"
                    :href="showUlcHeaderFooter ? 'http://ulc.asu.edu/' : 'https://ea.asu.edu'"
                    @click="asuoDataLayerClick('SecondaryHeaderComponent', '9')"
                    ><strong> Universal Learner® Courses</strong></a
                  >
                </div>
                <div
                  v-else
                  style="font: normal normal bold 32px/48px Arial"
                  @click="asuoDataLayerClick('SecondaryHeaderComponent', '9')"
                >
                  {{ showUlcHeaderFooter ? 'ASU Universal Learner Courses' : 'Earned Admission' }}
                </div>
                <div v-if="isLoggedin" style="font: normal normal bold 24px/28px Arial" class="pt-2">
                  Learner Portal
                </div>
              </div>

              <!-- Secondary Header Section -->
              <div>
                <div v-if="isLoggedin">
                  <secondary-header-component
                    :adminUserName="adminUserName"
                    :isPathwaysAllowed="isPathwaysAllowed"
                    @updateAdminUserName="updateAdminUserName"
                    @refreshDashboard="refreshDashboard"
                  />
                </div>
                <div v-else>
                  <login-secondary-header-component
                    :loggedOutNavBarMenu="showUlcHeaderFooter ? ulcLoggedOutNavBarMenu : eaLoggedOutNavBarMenu"
                  />
                </div>
              </div>
            </v-col>
          </v-row>
        </v-container>

        <!-- Mobile header bar -->
        <div
          class="d-flex d-md-none align-center justify-space-between"
          style="padding: 12px 24px; background: #fff; border-bottom: 1px solid #bfbfbf"
        >
          <!-- Left: Hamburger / Close -->
          <button
            aria-label="Toggle menu"
            style="
              width: 44px;
              height: 44px;
              display: flex;
              align-items: center;
              justify-content: center;
              background: none;
              border: none;
              cursor: pointer;
              border-radius: 50%;
              flex-shrink: 0;
            "
            :style="mobileHeader ? 'background: #e8e8e8;' : ''"
            @click="
              mobileHeader = !mobileHeader;
              asuoDataLayerClick('MobileHeader', '0', { action: isOpen() });
            "
          >
            <v-icon size="28" color="#191919">{{ mobileHeader ? 'mdi-close' : 'mdi-menu' }}</v-icon>
          </button>

          <!-- Center: Title -->
          <div class="text-center" style="flex: 1; min-width: 0">
            <div style="display: inline-block; text-align: left">
              <div
                style="font: normal normal bold 20px/24px Arial; color: #000"
                @click="asuoDataLayerClick('SecondaryHeaderComponent', '9')"
              >
                {{ showUlcHeaderFooter ? 'Universal Learner Courses' : 'Earned Admission' }}
              </div>
              <div v-if="isLoggedin" style="font: normal normal bold 16px/20px Arial; color: #000; margin-top: 2px">
                Learner Portal
              </div>
            </div>
          </div>

          <!-- Right: Notification bell -->
          <div v-if="isLoggedin" style="flex-shrink: 0">
            <DashboardNotificationDropdown />
          </div>
          <div v-else style="width: 44px; flex-shrink: 0" />
        </div>

        <!-- Mobile menu content -->
        <div v-if="mobileHeader" class="d-md-none" style="overflow-y: auto">
          <MobileNavBar
            :loggedInNavBarMenu="loggedInNavBarMenu"
            :loggedOutNavBarMenu="showUlcHeaderFooter ? ulcLoggedOutNavBarMenu : eaLoggedOutNavBarMenu"
            :mobileHeader="mobileHeader"
            :isLoggedin="isLoggedin"
            :isNotInRegisterationPage="isNotInRegisterationPage"
            :isPathwaysAllowed="isPathwaysAllowed"
            @doLogOut="doLogOut"
            @close="mobileHeader = false"
          />
        </div>
      </div>
    </div>

    <!-- Canvas Incident Banner -->
    <canvas-incident-banner :show="showCanvasIncidentBanner" @close="closeCanvasIncidentBanner" />

    <!-- Salesforce-driven banner announcements (category banner_red/blue/yellow) -->
    <notice-banner
      v-for="banner in bannerAnnouncements"
      :key="banner.id"
      :variant="bannerVariant(banner.category)"
      :title="banner.name || ''"
      :message="bannerMessage(banner.body)"
      html
    />

    <AnnouncementBanner v-if="isacceleratePartnerURLSubDomain" style="background-color: #f1f1f1" />
  </div>
</template>
<script>
import { defineComponent } from 'vue';
import { useAuthStore, useUserStore } from '../stores';

import { Logger } from '../mixins/logger';
import { DataLayerMixin } from '../mixins/dataLayerMixin.js';
import MobileNavBar from './MobileNavBar.vue';
import DashboardNotificationDropdown from './accelerate/DashboardNotificationDropdown.vue';
import { Helper } from '../mixins/helpers.js';
import AnnouncementBanner from './accelerate/AnnouncementBanner.vue';
import CanvasIncidentBanner from './CanvasIncidentBanner.vue';
import NoticeBanner from './NoticeBanner.vue';
import { bannerVariantFromCategory, bannerMessageFromBody } from '../util/banners';

export default defineComponent({
  emits: ['updateAdminUserName', 'refreshDashboard'],

  components: {
    MobileNavBar,
    DashboardNotificationDropdown,
    AnnouncementBanner,
    CanvasIncidentBanner,
    NoticeBanner
  },

  data() {
    return {
      blueBannerShown: true,
      mobileHeader: false,
      isPathwaysAllowed: false,
      desktopSearchText: '',
      mobileSearchText: '',
      showCanvasIncidentBanner: false,
      loggedInNavBarMenu: [
        {
          title: 'Dashboard',
          route: '/dashboard',
          dataLayerIndex: '0'
        },
        {
          title: 'My Courses',
          route: '/my-courses',
          dataLayerIndex: '2'
        },
        {
          title: 'Add Courses',
          route: '/courses-add',
          dataLayerIndex: '1'
        },
        {
          title: 'Pathways',
          route: '/my-pathway',
          dataLayerIndex: '7'
        },
        {
          title: 'Profile',
          route: '/profile',
          dataLayerIndex: '8'
        },
        {
          title: 'Help',
          href: 'https://ea.asu.edu/about/faq',
          dataLayerIndex: '4'
        }
      ],
      eaLoggedOutNavBarMenu: [
        {
          isActive: false,
          htmlLink: {
            text: 'Home',
            uri: '/'
          },
          children: [],
          dataLayerIndex: 0
        },
        {
          isActive: false,
          htmlLink: {
            text: 'How it works',
            uri: 'https://www.asu.edu/'
          },
          children: [
            {
              isActive: false,
              htmlLink: {
                text: 'Overview',
                uri: 'https://ea.asu.edu/how-it-works/',
                target: '_blank'
              }
            },
            {
              isActive: false,
              htmlLink: {
                text: 'Explore ASU degrees',
                uri: 'https://ea.asu.edu/how-it-works/explore-degree-options/',
                target: '_blank'
              }
            },
            {
              isActive: false,
              htmlLink: {
                text: 'Pricing',
                uri: 'https://ea.asu.edu/how-it-works/pricing/',
                target: '_blank'
              }
            },
            {
              isActive: false,
              htmlLink: {
                text: 'International learners',
                uri: 'https://ea.asu.edu/how-it-works/international-learners/',
                target: '_blank'
              }
            }
          ]
        },
        {
          isActive: false,
          htmlLink: {
            text: 'Courses',
            uri: 'https://ea.asu.edu/courses/',
            target: '_blank'
          },
          children: [
            {
              isActive: false,
              htmlLink: {
                text: 'Overview',
                uri: 'https://ea.asu.edu/courses/',
                target: '_blank'
              }
            },
            {
              isActive: false,
              htmlLink: {
                text: 'Most popular',
                uri: 'https://ea.asu.edu/courses/most-popular/',
                target: '_blank'
              }
            },
            {
              isActive: false,
              htmlLink: {
                text: 'Degree Pathways',
                uri: 'https://ea.asu.edu/courses/degree-pathways/',
                target: '_blank'
              }
            },
            {
              isActive: false,
              htmlLink: {
                text: 'Certificates',
                uri: 'https://ea.asu.edu/courses/certificates/',
                target: '_blank'
              }
            },
            {
              isActive: false,
              htmlLink: {
                text: 'Course catalog',
                uri: 'https://courses.ea.asu.edu/',
                target: '_blank'
              }
            }
          ]
        },
        {
          isActive: false,
          htmlLink: {
            text: 'Success stories',
            uri: 'https://ea.asu.edu/student-success-stories/',
            target: '_blank'
          },
          children: []
        },
        {
          isActive: false,
          htmlLink: {
            text: 'Help center',
            uri: 'https://www.asu.edu/'
          },
          children: [
            {
              isActive: false,
              htmlLink: {
                text: 'Overview',
                uri: 'https://ea.asu.edu/help-center/',
                target: '_blank'
              }
            },
            {
              isActive: false,
              htmlLink: {
                text: 'FAQs',
                uri: 'https://ea.asu.edu/help-center/faqs/',
                target: '_blank'
              }
            },
            {
              isActive: false,
              htmlLink: {
                text: 'Proctoring',
                uri: 'https://ea.asu.edu/help-center/proctoring/',
                target: '_blank'
              }
            },
            {
              isActive: false,
              htmlLink: {
                text: 'Accessibility',
                uri: 'https://ea.asu.edu/help-center/accessibility/',
                target: '_blank'
              }
            },
            {
              isActive: false,
              htmlLink: {
                text: 'Technical Requirements',
                uri: 'https://ea.asu.edu/technical-requirements/',
                target: '_blank'
              }
            }
          ]
        },
        {
          isActive: false,
          htmlLink: {
            text: 'Partner with us',
            uri: 'https://learning.asu.edu/partner-with-us/',
            target: '_target'
          },
          children: []
        }
      ],
      ulcLoggedOutNavBarMenu: [
        {
          isActive: false,
          htmlLink: {
            text: 'Home',
            uri: '/'
          },
          children: [],
          dataLayerIndex: 0
        },
        {
          isActive: false,
          htmlLink: {
            text: 'How it works',
            uri: 'https://www.asu.edu/'
          },
          children: [
            {
              isActive: false,
              htmlLink: {
                text: 'How to enroll',
                uri: 'https://ulc.asu.edu/how-to-enroll/',
                target: '_blank'
              }
            },
            {
              isActive: false,
              htmlLink: {
                text: 'Pricing',
                uri: 'https://ulc.asu.edu/how-to-enroll/pricing/',
                target: '_blank'
              }
            },
            {
              isActive: false,
              htmlLink: {
                text: 'How to get college credit',
                uri: 'https://ulc.asu.edu/how-to-enroll/how-to-get-college-credit/',
                target: '_blank'
              }
            },
            {
              isActive: false,
              htmlLink: {
                text: 'International learners',
                uri: 'https://ulc.asu.edu/how-to-enroll/international-learners/',
                target: '_blank'
              }
            },
            {
              isActive: false,
              htmlLink: {
                text: 'Pay with 529',
                uri: 'https://ulc.asu.edu/how-it-works/pay-with-529/',
                target: '_blank'
              }
            }
          ]
        },
        {
          isActive: false,
          htmlLink: {
            text: 'Explore courses',
            uri: 'https://ulc.asu.edu/explore-courses/',
            target: '_blank'
          },
          children: [
            {
              isActive: false,
              htmlLink: {
                text: 'Overview',
                uri: 'https://ulc.asu.edu/explore-courses/',
                target: '_blank'
              }
            },
            {
              isActive: false,
              htmlLink: {
                text: 'Most popular',
                uri: 'https://ulc.asu.edu/explore-courses/most-popular/',
                target: '_blank'
              }
            },
            {
              isActive: false,
              htmlLink: {
                text: 'For high school students',
                uri: 'https://ulc.asu.edu/explore-courses/for-high-school-students/',
                target: '_blank'
              }
            },
            {
              isActive: false,
              htmlLink: {
                text: 'By interests and careers',
                uri: 'https://ulc.asu.edu/explore-courses/by-interests-and-careers/',
                target: '_blank'
              }
            },
            {
              isActive: false,
              htmlLink: {
                text: 'Foundations certificates',
                uri: 'https://ulc.asu.edu/explore-courses/foundations-certificates/',
                target: '_blank'
              }
            },
            {
              isActive: false,
              htmlLink: {
                text: 'Degree pathways',
                uri: 'https://ulc.asu.edu/degree-pathways/',
                target: '_blank'
              }
            },
            {
              isActive: false,
              htmlLink: {
                text: 'Arizona diploma seals',
                uri: 'https://ulc.asu.edu/arizona-diploma-seals/',
                target: '_blank'
              }
            },
            {
              isActive: false,
              htmlLink: {
                text: 'Course catalog',
                uri: 'https://courses.ulc.asu.edu/',
                target: '_blank'
              }
            }
          ]
        },
        {
          isActive: false,
          htmlLink: {
            text: 'Help center',
            uri: 'https://www.asu.edu/'
          },
          children: [
            {
              isActive: false,
              htmlLink: {
                text: 'Overview',
                uri: 'https://ulc.asu.edu/help-center/',
                target: '_blank'
              }
            },
            {
              isActive: false,
              htmlLink: {
                text: 'FAQs',
                uri: 'https://ulc.asu.edu/help-center/faqs/',
                target: '_blank'
              }
            },
            {
              isActive: false,
              htmlLink: {
                text: 'Proctoring',
                uri: 'https://ulc.asu.edu/help-center/proctoring/',
                target: '_blank'
              }
            },
            {
              isActive: false,
              htmlLink: {
                text: 'Accessibility',
                uri: 'https://ulc.asu.edu/help-center/accessibility/',
                target: '_blank'
              }
            },
            {
              isActive: false,
              htmlLink: {
                text: 'Technical Requirements',
                uri: 'https://ulc.asu.edu/technical-requirements/',
                target: '_blank'
              }
            }
          ]
        },
        {
          isActive: false,
          htmlLink: {
            text: 'ASU Universal Pathways',
            uri: 'https://www.asu.edu/'
          },
          children: [
            {
              isActive: false,
              htmlLink: {
                text: 'Overview',
                uri: 'https://ulc.asu.edu/asu-universal-pathways/',
                target: '_blank'
              }
            },
            {
              isActive: false,
              htmlLink: {
                text: 'Transfer credits',
                uri: 'https://ulc.asu.edu/asu-universal-pathways/transfer-credits/',
                target: '_blank'
              }
            }
          ]
        },
        {
          isActive: false,
          htmlLink: {
            text: 'Newsroom',
            uri: 'https://ulc.asu.edu/newsroom/',
            target: '_blank'
          },
          children: []
        }
      ]
    };
  },

  mixins: [Helper, Logger, DataLayerMixin],

  props: {
    adminUserName: String,
    nav: String
  },

  methods: {
    bannerVariant(category) {
      return bannerVariantFromCategory(category);
    },
    bannerMessage(body) {
      return bannerMessageFromBody(body);
    },
    searchAsu() {
      let searchText = '';

      searchText = this.desktopSearchText || this.mobileSearchText;

      window.open(`https://search.asu.edu/?q=${searchText}`, '_blank');
    },
    isOpen() {
      return this.mobileHeader ? 'open' : 'close';
    },
    login() {
      this.logInfo('calling asurite login from app header');

      this.$auth.login('asurite');
    },
    // Polls until isReady() is true, and gives up at the deadline. Resolves with
    // whether the condition was actually met. Pending ids are tracked on the
    // instance (deliberately not in data - they are opaque timer handles, not
    // view state) so beforeUnmount can clear them.
    waitFor(isReady, { timeoutMs = 10000, intervalMs = 100 } = {}) {
      return new Promise((resolve) => {
        if (isReady()) {
          resolve(true);
          return;
        }

        const deadline = Date.now() + timeoutMs;
        const id = setInterval(() => {
          const ready = isReady();

          if (!ready && Date.now() < deadline) return;

          this.stopPolling(id);
          resolve(ready);
        }, intervalMs);

        this.pollIntervals = [...(this.pollIntervals || []), id];
      });
    },
    stopPolling(id) {
      clearInterval(id);

      this.pollIntervals = (this.pollIntervals || []).filter((pending) => pending !== id);
    },
    checkIftlbtlbLoaded() {
      return this.waitFor(() => document.querySelectorAll('.tlb').length >= 8);
    },
    checkIfPartnerDataLoaded() {
      return this.waitFor(() => Boolean(this.$conn.partnerData));
    },
    checkIfLearnerDataLoaded() {
      return this.waitFor(() => Boolean(this.$conn.learnerData));
    },
    updateAdminUserName(name) {
      this.$emit('updateAdminUserName', name);
    },
    refreshDashboard() {
      this.$emit('refreshDashboard');
    },
    closeCanvasIncidentBanner() {
      this.showCanvasIncidentBanner = false;
    },
    async doLogOut() {
      try {
        this.logInfo('do logout app header');

        this.$session.remove('contactFormModel');
        this.$session.remove('LearnerFormModel');

        await this.$auth.logOut();
      } catch (error) {
        // Error during logout
      }
    }
  },

  computed: {
    authStore() {
      return useAuthStore();
    },
    userStore() {
      return useUserStore();
    },
    bannerAnnouncements() {
      return this.userStore.apis?.learnerData?._bannerAnnouncements || [];
    },
    isNotInRegisterationPage() {
      let route = this.$route.name;
      let resiterationRoutes = [
        'login',
        'WelcomeDesktop',
        'register',
        'Registerv2',
        'SignupConfirmation',
        'ConfirmRegistrationv2'
      ];
      return resiterationRoutes.filter((e) => {
        return route === e;
      }).length > 0
        ? false
        : true;
    },

    welcomeTitle() {
      return this.userStore.welcomePageData?.studentPortalTitle || '&nbsp;';
    },

    isLoggedin: function () {
      // Use both store state (for reactivity) and AuthManager service (for accuracy)
      // Also ensure we're not in signup flow
      return !this.authStore.performSignup && this.authStore.auth && this.$auth && this.$auth.isAuthenticated();
    },

    partnerLogo() {
      return this.userStore.welcomePageData?.partnerLogo;
      // return ((this.$conn.partnerData || {}).welcomePageData || {})
      // 	.partnerLogo;
    },
    showUlcHeaderFooter() {
      // Check if the partner name  for ULC header and footer
      const partnerName = this.$conn.getPartnerName();
      if (partnerName === 'accelerate' || partnerName === 'kipp' || partnerName === 'hs4cc') {
        return true;
      }
      return Helper.methods.isUlcPartner();
    },
    isacceleratePartnerURLSubDomain() {
      return Helper.methods.isAcceleratePartner(this.userStore.apis?.learnerData?._partnerURLSubDomain);
    }
  },

  async created() {
    try {
      await this.checkIftlbtlbLoaded();
      if (this.isLoggedin == true) {
        if (document.querySelectorAll('.tlb')[8]) document.querySelectorAll('.tlb')[8].style.display = 'none';
        if (document.querySelectorAll('.tlb')[9]) document.querySelectorAll('.tlb')[9].style.display = 'none';
      } else {
        if (document.querySelectorAll('.tlb')[7]) document.querySelectorAll('.tlb')[7].style.display = 'none';
        if (document.querySelectorAll('.tlb')[6]) document.querySelectorAll('.tlb')[6].style.display = 'none';
      }
      await this.checkIfPartnerDataLoaded();
      await this.checkIfLearnerDataLoaded();

      this.isPathwaysAllowed = this.$conn.learnerData?._isPathwaysAllowed || false;
    } catch (error) {
      // Error in AppHeader created hook
    }
  },

  beforeUnmount() {
    (this.pollIntervals || []).forEach((id) => clearInterval(id));

    this.pollIntervals = [];
  }
});
</script>
